module.exports = __webpack_public_path__ + "img/94.421dd49f.jpg";